import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {Token} from '../models/token';
import {environment} from '../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor() {}
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const storage = environment.strictLogout ? sessionStorage : localStorage;
		if (storage.getItem(Token.tokeNameInSotage) && !request.headers.get('Authorization')) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${storage.getItem(Token.tokeNameInSotage)}`
				}
			});
		}
		return next.handle(request);
	}
}
